export default {"src":"/_next/static/media/x.4138a3f8.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};